export default {
  profile: '個人中心',
  settings: '系統設置',
  createContentTip: '創建新內容時，該內容歸屬於 {label}，請使用{label}錄入',
  createContentExample: '例如：新建產品時，產品名稱、描述等欄位請使用',
  langLevel: '基礎: {label}',
};
